import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
import './VantRegister.js'
import '@/permission' // permission control
import globalVariable from '@/api/global_variable.js' // 引入全局变量
import BottomMarker from '@/components/BottomMarker' // 引入全局组件
import * as echarts from 'echarts'
import { TextBox } from 'vant-green';
import { Search } from 'vant-green';
import dataV from '@jiaminghi/data-view'
import "swiper/css/swiper.min.css"
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
Vue.use(Search);
Vue.component('Swiper', Swiper);
Vue.component('SwiperSlide', SwiperSlide);
// Swiper 代表最外侧容器
// SwiperSlide 代表每一张轮播图


Vue.prototype.$globalVariable = globalVariable // 全局变量模块挂载到 Vue.prototype
Vue.prototype.$echarts = echarts
// Vue.component('BottomMarker', BottomMarker) // 注册全局组件
Vue.config.productionTip = false
Vue.use(dataV)
Vue.use(TextBox);
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
